import React, { useRef, useState } from 'react'
import { URL } from '../../api'
import { Button, Card } from 'reactstrap'
import { BiCloudUpload, BiEdit } from 'react-icons/bi'
import { useTranslation } from 'react-i18next';

const FileUploader = ({ title, imageUrl, onFileSelect }) => {
    const [dragActive, setDragActive] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const { t } = useTranslation();
    const inputRef = useRef(null);

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            onFileSelect(e.dataTransfer.files[0]);
        }
    };

    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            onFileSelect(e.target.files[0]);
        }
    };

    const handleButtonClick = () => {
        inputRef.current.click();
    };

    return (
        <Card className="p-3 h-100">
            <div className="d-flex justify-content-between mb-2">
                <h5 className="mb-0">{title}</h5>
                {imageUrl && (
                    <Button
                        color="warning"
                        size="sm"
                        className="text-white"
                        onClick={handleButtonClick}
                    >
                        <BiEdit size={18} className="mr-1" /> {t("edit")}
                    </Button>
                )}
            </div>

            {imageUrl ? (
                <div
                    className="position-relative mt-2 h-100 d-flex align-items-center"
                    style={{ overflow: 'hidden', borderRadius: '8px' }}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                >
                    <img
                        src={`${URL}${imageUrl}`}
                        alt={title}
                        className="w-100"
                        style={{
                            transition: 'all 0.3s',
                            filter: isHovering ? 'brightness(0.7)' : 'brightness(1)'
                        }}
                    />

                    {isHovering && (
                        <div
                            className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                            style={{ top: 0, left: 0 }}
                        >
                            <Button
                                color="primary"
                                onClick={handleButtonClick}
                                className="shadow"
                            >
                                <BiEdit size={20} className="mr-2" /> {t("change_image")}
                            </Button>
                        </div>
                    )}

                    <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleChange}
                        style={{ display: 'none' }}
                    />
                </div>
            ) : (
                <div
                    className={`upload-container ${dragActive ? "drag-active" : ""}`}
                    onDragEnter={handleDrag}
                    onDragLeave={handleDrag}
                    onDragOver={handleDrag}
                    onDrop={handleDrop}
                    onClick={handleButtonClick}
                    style={{
                        border: '2px dashed #ccc',
                        borderRadius: '8px',
                        padding: '40px 20px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        backgroundColor: dragActive ? '#f0f9ff' : '#f8f9fa',
                        transition: 'all 0.3s ease',
                    }}
                >
                    <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleChange}
                        style={{ display: 'none' }}
                    />
                    <BiCloudUpload size={48} color="#5c6ac4" />
                    <h5 className="mt-3 mb-1">{t("upload_image")}</h5>
                    <p className="text-muted mb-0">
                        {t("drag_drop_or")} <span className="text-primary">{t("browse_files")}</span>
                    </p>
                    <p className="small text-muted mt-2">PNG, JPG {t("supported")}</p>
                </div>
            )}
        </Card>
    );
};

export default FileUploader
